<!-->╔════╦═════════════════════════════════════════════════════════════════════════════════╗<- ->
<- ->║ PA ║                            Generic Page Wrapper                                 ║<- ->
<- ->╚════╩═════════════════════════════════════════════════════════════════════════════════╝<--->

<template>
    <airblue-page>
        <component v-if="component" :is="component" />
    </airblue-page>
</template>

<script>
    import AirbluePage from ":/PA/common/airblue-page"

    export default {
        name: "Page.PA",
        components: { AirbluePage },

        data() {
            let page = window.app_page
                || Object.fromEntries(window.location.search.split(/[?&]/).filter(s => s).map(s => s.split('=')))["page"]

            return {
                page, component: () => import('./' + page)
            }
        }
    }
</script>